import React from 'react'
import { useText } from '../context/TextContext'

interface Props {
    dealCount: number
}

function DealsBadge(props: Props) {
    const { dealCount } = props
    const text = useText();

    return <div className='badge rounded-pill bg-primary' > {dealCount} {dealCount === 1 ? text.deal : text.deals} </div>
}

export default DealsBadge
